import { connect } from 'react-redux';
import * as R from 'ramda';
import Security from './Security';
import {
  fetchParentCompanies,
  fetchPermissionsForUser,
  getCanShowSidebar,
  getCurrentParentCompany,
  getGlobalCustomerMembers,
  getParentCompanies,
  getStoreValueByProp,
  resetSecurity,
  setDialogOpen,
  setLegendDrawerOpen,
  setMobileSidebarOpen,
  setParentCompaniesIndex,
  setTargetUser,
  updateUserPermission,
} from './securitySlice';

const mapStateToProps = R.applySpec({
  affiliates: getStoreValueByProp(['affiliates']),
  canShowSidebar: getCanShowSidebar,
  customerId: R.o(R.prop('customerId'), getCurrentParentCompany),
  dialogOpen: getStoreValueByProp(['dialogOpen']),
  legendDrawerOpen: getStoreValueByProp(['legendDrawerOpen']),
  mobileSidebarOpen: getStoreValueByProp(['mobileSidebarOpen']),
  permissionsPending: getStoreValueByProp(['permissionsPending']),
  targetUser: getStoreValueByProp(['targetUser']),
  targetUserPermissionsPending: getStoreValueByProp(['targetUserPermissionsPending']),
  userAffiliateTable: getStoreValueByProp(['userAffiliateTable']),
});

export default connect(mapStateToProps, {
  fetchParentCompanies,
  fetchPermissionsForUser,
  getGlobalCustomerMembers,
  getParentCompanies,
  resetSecurity,
  setDialogOpen,
  setLegendDrawerOpen,
  setMobileSidebarOpen,
  setParentCompaniesIndex,
  setTargetUser,
  updateUserPermission,
})(Security);
